<div>
	@if (productDetail) {
		<div class="row content-container">
			<div class="col-12 main-content">
				<div class="button-bar button-bar--justify">
					@switch (origin) {
						@case ('planthunter') {
							<button (click)="backToPrevious()"
							        class="button--text">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to planthunter link@@productdetail.back.to.planthunter">
										Back to planthunter
									</ng-container>
								</strong>
							</button>
						}
						@case ('blog') {
							<button (click)="backToPrevious()"
							        class="button--text">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to blog link@@productdetail.back.to.blog">
										Back to blog
									</ng-container>
								</strong>
							</button>
						}
						@case ('brand') {
							<button (click)="backToPrevious()"
							        class="button--text">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to brand link@@productdetail.back.to.brand">
										Back to brand
									</ng-container>
								</strong>
							</button>
						}
						@case ('cart') {
							<button (click)="backToPrevious()" class="button--text">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to cart link@@productdetail.back.to.cart">
										Back to cart
									</ng-container>
								</strong>
							</button>
						}
						@case ('scanner') {
							<button (click)="backToProductsAndOpenBarcodeScanner()" class="button--text">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to scanner link@@productdetail.back.to.barcode.scanner">
										Back to barcode scanner
									</ng-container>
								</strong>
							</button>
						}
						@default {
							<a [queryParams]="{ plantscaping: getPlantscapingFilter() }"
							   [routerLink]="['/products']"
							   fragment="{{ anchorValue }}">
								<strong>
									<svg class="icon-arrow-left"
									     height="10"
									     viewBox="0 0 6 10"
									     width="6">
										<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
									</svg>
									<ng-container i18n="Back to products link text@@back.to.products">
										Back to products
									</ng-container>
								</strong>
							</a>
						}
					}
				</div>

				<div class="product-detail">
					<h1 class="product-detail_title">
						{{ productDetail.totalDescription1 }}
					</h1>

					@if (productDetail.totalDescription2.trim().length > 0) {
						<p class="product-detail_description">
							{{ productDetail.totalDescription2 }}
						</p>
					}

					<!-- TODO: OPXNOV-1819 - Styling for mobile is not done yet. -->
					<div class="product-detail__main-wrapper">
						<div class="product-detail__main-information">
							<div class="product-detail__image-carousel">
								<render-product-image-carousel [additionalImages]="getAdditionalImages()"
								                               [productTitle]="productDetail.totalDescription1" />
							</div>

							@if (hasAdditionalImages()) {
								<div class="product-detail__thumbnail-carousel mobile-visible">
									<render-product-thumbnail-carousel (gotoSlide)="triggerGoToSlide($event)"
									                                   [additionalImages]="getAdditionalImages()"
									                                   [productTitle]="productDetail.totalDescription1" />
								</div>
							}

							<div class="product-detail__sales-information">
								<productdetail-product-price-and-buy-button [productDetail]="productDetail"
								                                            [productPrices]="productPrices" />

								<product-detail-labels [productDetail]="productDetail" />

								<product-detail-extra-information [productDetail]="productDetail" />
							</div>
						</div>

						@if (hasAdditionalImages()) {
							<div class="product-detail__thumbnail-carousel mobile-hidden">
								<render-product-thumbnail-carousel (gotoSlide)="triggerGoToSlide($event)"
								                                   [additionalImages]="getAdditionalImages()"
								                                   [productTitle]="productDetail.totalDescription1" />
							</div>
						}

						<product-detail-features [productDetail]="productDetail" />

						@if (productDetail.plantscapingExtraInfo) {
							<div class="product-detail__product-information">
								<h3 i18n="Product information header@@product.detail.productinformation">
									Productinformation
								</h3>
								<p [innerHTML]="productDetail.plantscapingExtraInfo"></p>
							</div>
						}
					</div>

					@if (productDetail.grower && userService.isLoggedIn()) {
						<product-grower-blog
								[grower]="productDetail.grower" />
					}

					@if (isProductSoldOut()) {
						<alternative-products [itemNo]="itemNo"
						                      [limit]="4"
						                      [potHeightFrom]="potHeightFrom"
						                      [potHeightTill]="potHeightTill"
						                      [potSizeFrom]="potSizeFrom"
						                      [potSizeTill]="potSizeTill" />
					}

					@if (!productDetail.available) {
						<not-available-alternative-products [product]="productDetail" />
					}

					@if (!isProductSoldOut() && productDetail.available) {
						<grower-products [limit]="4"
						                 [product]="productDetail" />
					}

					@if (productDetail.type === 3) {
						<product-order-history [limit]="3"
						                       [product]="productDetail" />
					}
				</div>
			</div>
		</div>
	}
</div>
